import { FormControl } from 'react-bootstrap'
import type { RefObject } from 'react'
import React from 'react'
import type { FormControlProps } from 'react-bootstrap/FormControl'
import styles from './textarea-input.module.scss'
import type { FieldEditorInjectedProps } from '../FieldEditorInjectedProps'
import type { InlineInputInjectedProps } from '../InlineInputInjectedProps'

export type TextAreaInputProps = Omit<FormControlProps, 'form'> &
  FieldEditorInjectedProps &
  InlineInputInjectedProps & {
    rows?: number
    submitting?: boolean
    inputRef?: RefObject<HTMLTextAreaElement>
  }
export const TextAreaInput = ({
  submitting,
  disabled,
  inputRef,
  className,
  form: _form,
  meta: _meta,
  isDisabled: _isDisabled,
  noLabel: _noLabel,
  saveNow: _saveNow,
  cancelNow: _cancelNow,
  setNewValue: _setNewValue,
  documentId: _documentId,
  initialValues: _initialValues,
  validate: _validate,
  canEdit: _canEdit,
  editable: _editable,
  inputProps: _inputProps,
  ...props
}: TextAreaInputProps) => {
  return (
    <FormControl
      ref={inputRef}
      as="textarea"
      autoFocus={true}
      disabled={disabled || submitting}
      className={`${className ?? ''} ${styles.textareaInput}`}
      {...props}
    />
  )
}
